import type { FC } from 'react'

import type { EventCard } from '@segment/api/routes/events/queries'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface EventsGridProps {
  events: EventCard[] | undefined
  isLoading: boolean
  title: string | null
}
const EventsGrid: FC<EventsGridProps> = ({ events, isLoading, title }) => {
  return (
    <CardsSection isLoading={isLoading} title={title}>
      <CardsGroup data-testid="cards-grid" aria-live="polite" aria-busy={isLoading}>
        {events?.map(({ title, ctaText, url, dateStr, eventType, region, content }) => (
          <Card
            key={title}
            title={title}
            ctaText={ctaText}
            url={url}
            dateStr={dateStr}
            eventType={eventType}
            region={region}
            content={content}
          />
        ))}
      </CardsGroup>
    </CardsSection>
  )
}

export default EventsGrid
